import { createFileRoute } from "@tanstack/react-router";
import { ReportPage } from "@/modules/reports/presentation/pages/ReportPage";

export const Route = createFileRoute("/_authenticated/report")({
  component: ReportPage,
});
